import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import { ProtectedRoute } from './routes/ProtectedRoute';
import Navbar from './components/Navbar/Navbar';
import Home from './pages/Home/Home';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import Cart from './pages/Cart/Cart';
import MyLearning from './pages/MyLearning/MyLearning';
import CourseDetails from './pages/CourseDetails/CourseDetails';
import CoursePlayer from './pages/CoursePlayer/CoursePlayer';
import CourseStart from './pages/CourseStart/CourseStart';
import TextLesson from './pages/TextLesson/TextLesson';
import Playground from './pages/Playground/Playground';
import Payment from './pages/Payment/Payment';
import Certificates from './pages/Certificates/Certificates';
import Profile from './pages/Profile/Profile';
import Messages from './pages/Messages/Messages';
import Legal from './pages/Legal/Legal';
import Footer from './components/Footer/Footer';
import './App.css';

function AppLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <CartProvider>
      <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route
            path="/login"
            element={
              <AppLayout>
                <Login />
              </AppLayout>
            }
          />
          <Route
            path="/signup"
            element={
              <AppLayout>
                <Signup />
              </AppLayout>
            }
          />
          <Route
            path="/"
            element={
              <AppLayout>
                <Home />
              </AppLayout>
            }
          />
          <Route
            path="/my-learning"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <MyLearning />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/playground"
            element={
              <AppLayout>
                <Playground />
              </AppLayout>
            }
          />
          <Route
            path="/course/:courseId"
            element={
              <AppLayout>
                <CourseStart />
              </AppLayout>
            }
          />
          <Route
            path="/course/:courseId/overview"
            element={
              <AppLayout>
                <CourseDetails />
              </AppLayout>
            }
          />
          <Route
            path="/course/:courseId/pay"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Payment />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/:courseId/learn"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <CoursePlayer />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/:courseId/learn/:lessonId"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <CoursePlayer />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/course/:courseId/read/:lessonId"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <TextLesson />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/certificates"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Certificates />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Profile />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Messages />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/cart"
            element={
              <AppLayout>
                <Cart />
              </AppLayout>
            }
          />
          <Route
            path="/legal/:slug"
            element={
              <AppLayout>
                <Legal />
              </AppLayout>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </LanguageProvider>
      </CartProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}
